import React from 'react';
import AnimatedBackground from '../components/AnimatedBackground';
import SEO from '../components/SEO';
import ReviewsCarousel from '../components/ReviewsCarousel';
import { CALENDLY_LINK } from '../constants';
import './Landingspagina.css';

export default function Landingspagina() {

    return (
        <div className="landingspagina">
            <SEO
                title="Veloce Software - Intelligente Workflow Automatisering"
                description="Automatiseer uw bedrijfsprocessen met slimme software. Van inventarisatie tot implementatie en testing."
            />
            <section className="hero">
                <AnimatedBackground />
                <div className="hero-content">
                    <h1>Stroomlijn uw bedrijf met Intelligente Automatisering</h1>
                    <p className="tagline">Van chaos naar gestroomlijnde workflows in 3 stappen.</p>
                    <p className="description">
                        Wij helpen bedrijven efficiënter te werken door handmatige processen te automatiseren met slimme koppelvlakken.
                        Minder fouten, meer tijd voor groei.
                    </p>
                    <button onClick={() => window.open(CALENDLY_LINK, '_blank')} className="cta-button">
                        Start met Automatiseren
                        <span className="arrow">→</span>
                    </button>
                </div>
            </section>

            <section className="core-values">
                <div className="core-values-grid">
                    <div className="value-card">
                        <div className="value-content">
                            <div className="value-icon">
                                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                                    <path d="M15 14c.2-1 .7-1.7 1.5-2.5 1-1 1.5-2 1.5-3.5a6 6 0 0 0-11 0c0 1.5.5 2.5 1.5 3.5.8.8 1.3 1.5 1.5 2.5" />
                                    <path d="M9 18h6" />
                                    <path d="M10 22h4" />
                                </svg>
                            </div>
                            <h3>Innovatief</h3>
                            <p>Wij gebruiken de nieuwste AI technologieën om uw bedrijfsprocessen toekomstbestendig te maken. Geen ouderwetse oplossingen, maar state-of-the-art automatisering.</p>
                        </div>
                    </div>
                    <div className="value-card">
                        <div className="value-content">
                            <div className="value-icon">
                                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                                    <circle cx="12" cy="12" r="10" />
                                    <circle cx="12" cy="12" r="6" />
                                    <circle cx="12" cy="12" r="2" />
                                </svg>
                            </div>
                            <h3>Resultaatgericht</h3>
                            <p>Focus op meetbare efficiëntie. Wij automatiseren niet om het automatiseren, maar om uw bedrijfsresultaten direct te verbeteren en kosten te besparen.</p>
                        </div>
                    </div>
                    <div className="value-card">
                        <div className="value-content">
                            <div className="value-icon">
                                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                                    <path d="M14.7 6.3a1 1 0 0 0 0 1.4l1.6 1.6a1 1 0 0 0 1.4 0l3.77-3.77a6 6 0 0 1-7.94 7.94l-6.91 6.91a2.12 2.12 0 0 1-3-3l6.91-6.91a6 6 0 0 1 7.94-7.94l-3.76 3.76z" />
                                </svg>
                            </div>
                            <h3>Pragmatisch</h3>
                            <p>Praktische oplossingen die direct werken. Geen eindeloze adviesrapporten, maar werkende software die uw dagelijkse problemen oplost.</p>
                        </div>
                    </div>
                </div>
            </section>

            <section className="highlights">
                <h2>Onze Werkwijze</h2>
                <div className="process-timeline">
                    <div className="timeline-item">
                        <div className="timeline-number">1</div>
                        <div className="timeline-content">
                            <h3>Inventarisatie</h3>
                            <p>Als eerste zal er een kort en vrijblijvend online gesprek plaatsvinden van ongeveer 30 minuten om af te stemmen waar AI uw bedrijf het beste mee kan helpen. Hierbij kunnen wij samen met jou kijken welke stap in jouw bedrijf zich het best leent om te automatiseren met AI.</p>
                        </div>
                    </div>
                    <div className="timeline-item">
                        <div className="timeline-number">2</div>
                        <div className="timeline-content">
                            <h3>Deep dive</h3>
                            <p>Wanneer wij een passende stap hebben gevonden om te automatiseren zal er een tweede gesprek online of fysiek plaatsvinden. Hier gaan wij wat verder de diepte in over een passende oplossing en wat het verwachte gedrag van het AI model zou moeten zijn.</p>
                        </div>
                    </div>
                    <div className="timeline-item">
                        <div className="timeline-number">3</div>
                        <div className="timeline-content">
                            <h3>Offerte</h3>
                            <p>Op basis van wat er is besproken zal er een offerte worden overhandigd, deze zal altijd een vast bedrag zijn met garantie op basis van de hoeveelheid werk van de opdracht. Geen risico op bijkomende kosten dus.</p>
                        </div>
                    </div>
                    <div className="timeline-item">
                        <div className="timeline-number">4</div>
                        <div className="timeline-content">
                            <h3>Opstellen testscenario’s</h3>
                            <p>Op basis van het afgesproken resultaat van de Deep Dive stap, zullen er testscenario’s worden gemaakt. Wanneer zij deze hebben opgezet zullen wij deze samen met jou aanpassen en verbeteren. Deze zal worden gebruikt om te verifiëren of de gemaakte workflow het juiste resultaat teruggeeft.</p>
                        </div>
                    </div>
                    <div className="timeline-item">
                        <div className="timeline-number">5</div>
                        <div className="timeline-content">
                            <h3>Ontwikkeling</h3>
                            <p>Vervolgens wordt de afgesproken oplossing ontwikkeld. Dit zal 1 tot 4 weken duren afhankelijk van de complexiteit en de gewenste oplossing. De testscenario’s gemaakt in de vorige stap zullen worden gebruikt om er zeker van te zijn dat de workflow het juiste resultaat teruggeeft.</p>
                        </div>
                    </div>
                    <div className="timeline-item">
                        <div className="timeline-number">6</div>
                        <div className="timeline-content">
                            <h3>Testen</h3>
                            <p>Nadat de ontwikkeling is voltooid geven wij de resultaten van de testscenario’s terug. Vervolgens geven wij jou de kans om zelf de nieuwe workflow te testen voordat deze live gaat.</p>
                        </div>
                    </div>
                    <div className="timeline-item">
                        <div className="timeline-number">7</div>
                        <div className="timeline-content">
                            <h3>Uitrol</h3>
                            <p>Wanneer alles is zoals verwacht zal de workflow worden uitgerold. De eerste 2 weken zal de workflow intensief worden gemonitord door ons, onverwachte resultaten zullen kosteloos door ons worden gerepareerd.</p>
                        </div>
                    </div>
                </div>
            </section>

            <ReviewsCarousel />

            <section className="cta-hero">
                <div className="cta-hero-background"></div>
                <div className="cta-hero-overlay"></div>
                <div className="cta-hero-content">
                    <h2>Klaar om uw processen te automatiseren?</h2>
                    <div className="cta-hero-buttons">
                        <button onClick={() => window.open(CALENDLY_LINK, '_blank')} className="cta-button-outline">
                            Gratis Adviesgesprek <span className="arrow">›</span>
                        </button>
                    </div>
                </div>
            </section>
        </div>
    );
}
